export default __webpack_public_path__ + "static/winter47-b5e313d7e39eb41e5511c86bd53bb7a5.webp";